import { GENDER, GENDER_IDENTITY } from '../../../../constants/common'

export const SEARCH_THRESHOLD = 20
export const GENDER_FILTER_THRESHOLD = 40
export const LIST_PAGE_SIZE = 20

const buildCanonicalMap = options =>
  Object.entries(options).reduce((map, [key, option]) => {
    map[option.id.toLowerCase()] = key
    map[option.value.toLowerCase()] = key
    return map
  }, {})

const genderByValue = buildCanonicalMap(GENDER)
const genderIdentityByValue = buildCanonicalMap(GENDER_IDENTITY)

const normalize = (raw, map) => {
  if (!raw) return null
  return map[String(raw).trim().toLowerCase()] || null
}

export const normalizeGender = member => normalize(member?.gender, genderByValue)
export const normalizeGenderIdentity = member => normalize(member?.genderIdentity, genderIdentityByValue)

// Returns every option with a disabled flag for values no member has, so the
// dropdown can grey them out. Empty when no member has the field at all, so
// the dropdown hides instead of rendering fully disabled.
const optionsFor = (members, options, normalizer) => {
  const present = new Set((members || []).map(normalizer))
  present.delete(null)
  if (present.size === 0) return []
  return Object.entries(options).map(([key, option]) => ({
    id: key,
    name: option.value,
    disabled: !present.has(key),
  }))
}

export const genderOptionsFor = members => optionsFor(members, GENDER, normalizeGender)
export const genderIdentityOptionsFor = members => optionsFor(members, GENDER_IDENTITY, normalizeGenderIdentity)

export function filterLinkedMembers(members, searchText, genderId, genderIdentityId) {
  const query = (searchText || '').trim().toLowerCase()
  return (members || []).filter(member => {
    if (query && !`${member.firstname || ''} ${member.lastname || ''}`.toLowerCase().includes(query)) {
      return false
    }
    if (genderId && normalizeGender(member) !== genderId) {
      return false
    }
    if (genderIdentityId && normalizeGenderIdentity(member) !== genderIdentityId) {
      return false
    }
    return true
  })
}
